<script>
import CandidateImage from '@/components/candidate/candidate-image.vue'
import candidateMixin from '@/mixins/candidateMixin'

export default {
  name: 'PreferredEducatorCard',
  components: { CandidateImage },
  mixins: [candidateMixin],
  props: {
    educator: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isFirst: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    educatorTypes() {
      return (this.educator.candidateTypes ?? []).map((t) => t.title).join(', ')
    },
  },
}
</script>

<template>
  <div class="preferred-card rounded-xl">
    <v-card
      outlined
      elevation="0"
      class="pa-3 d-flex align-center cursor-grab"
      :aria-label="
        $t('bookingCreateV2.selectEducatorsStep.preferredCardAriaLabel', [
          index + 1,
          educator.fullName,
        ])
      "
    >
      <div class="d-flex flex-column mr-4 flex-shrink-0">
        <v-btn
          x-small
          icon
          color="grey"
          :disabled="isFirst"
          :aria-label="
            $t(
              'bookingCreateV2.selectEducatorsStep.preferredCardMoveUpAriaLabel',
              [educator.fullName]
            )
          "
          @click="$emit('move-up')"
        >
          <v-icon size="20">mdi-arrow-up</v-icon>
        </v-btn>
        <v-icon
          class="flex-shrink-0 my-1"
          size="20"
          color="grey"
          :aria-label="
            $t(
              'bookingCreateV2.selectEducatorsStep.preferredCardDragAriaLabel',
              [educator.fullName]
            )
          "
        >
          mdi-drag-vertical
        </v-icon>
        <v-btn
          x-small
          icon
          color="grey"
          :disabled="isLast"
          :aria-label="
            $t(
              'bookingCreateV2.selectEducatorsStep.preferredCardMoveDownAriaLabel',
              [educator.fullName]
            )
          "
          @click="$emit('move-down')"
        >
          <v-icon size="20">mdi-arrow-down</v-icon>
        </v-btn>
      </div>

      <CandidateImage
        :id="educator.id"
        :full-name="educator.fullName"
        margin="mr-2"
        size="72"
        :font-size="22"
        rounded
      />

      <div class="flex-grow-1 ml-2 pt-1 overflow-hidden align-self-start">
        <button
          type="button"
          class="inline-text-btn display-xs ma-0 pa-0 text-truncate text-left w-100"
          data-testid="educator-name"
          @click="$emit('view-candidate', educator.id)"
        >
          {{ educator.fullName }}
        </button>
        <div class="text-sm mt-1">
          {{
            $t('bookingCreateV2.selectEducatorsStep.lastBookedLabel', [
              educator.lastBookedDate
                ? displayDate(educator.lastBookedDate)
                : $t('bookingCreateV2.selectEducatorsStep.lastBookedNever'),
            ])
          }}
        </div>
      </div>

      <v-btn
        icon
        small
        class="ml-1 flex-shrink-0"
        :aria-label="
          $t(
            'bookingCreateV2.selectEducatorsStep.preferredCardRemoveAriaLabel',
            [educator.fullName]
          )
        "
        data-testid="queue-remove-btn"
        @click="$emit('remove')"
      >
        <v-icon size="18">mdi-delete-outline</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>
